import React, { useState } from 'react';
const faqs = [{
  q: 'How do I receive the material?',
  a: 'You will receive an email with a secure download link immediately after purchase. High-res PDF.'
}, {
  q: 'Can I use it on my tablet or phone?',
  a: 'Yes. All volumes and the mobile planner are optimized for on-ice reference.'
}, {
  q: 'Is it a one-time payment?',
  a: 'Yes. Pay once for lifetime access to the vault.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-bg-alt py-20 sm:py-24 px-4" data-id="element-74">
      <div className="max-w-3xl mx-auto" data-id="element-75">
        <div className="text-center mb-12" data-id="element-76">
          <h2 className="text-3xl sm:text-5xl font-serif font-black text-text-main" data-id="element-77">
            FAQ
          </h2>
        </div>

        <div className="space-y-4" data-id="element-78">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className="bg-bg-main border border-border-light rounded-2xl overflow-hidden" data-id="element-79">
                <button className="w-full text-left px-6 py-5 flex items-center justify-between gap-4" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} data-id="element-80">
                  <span className="font-bold text-text-main text-lg" data-id="element-81">
                    {faq.q}
                  </span>
                  <span className={`text-2xl text-primary transition-transform ${isOpen ? 'rotate-45' : ''}`} data-id="element-82">
                    +
                  </span>
                </button>
                <div className={`px-6 overflow-hidden transition-all duration-300 ${isOpen ? 'max-h-96 pb-6 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-83">
                  <p className="text-text-sec text-base" data-id="element-84">{faq.a}</p>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}